(function () {
  const ROOT_SELECTOR = '[data-professional-dashboard]'
  const DEFAULT_API_PATH = '/api/dashboard/leaderboard'
  const DEFAULT_LIMIT = 5
  const PERIOD_TITLES = {
    month: 'Month',
    ytd: 'YTD',
    all: 'All-Time', 
    custom: 'Custom'
  }

  const formatCurrency = (value) => {
    const number = Number(value ?? 0)
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(number / 100)
  }

  const formatDate = (value) => {
    const date = typeof value === 'string' ? new Date(value) : value
    if (!date || Number.isNaN(date.getTime())) return null
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
  }

  const ensureStyles = () => {
    if (document.getElementById('professional-dashboard-styles')) return
    const style = document.createElement('style')
    style.id = 'professional-dashboard-styles'
    style.textContent = `
      .professional-dashboard-table {
        border-collapse: collapse;
        width: 100%;
        font-family: inherit;
        color: #f8fafc;
      }
      .professional-dashboard-table th,
      .professional-dashboard-table td {
        padding: 8px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
      }
      .professional-dashboard-table th {
        text-transform: uppercase;
        letter-spacing: 0.08em;
        font-size: 0.65rem;
        color: rgba(148, 163, 184, 0.8);
        font-weight: 600;
      }
      .professional-dashboard-table tbody tr:last-child td {
        border-bottom: none;
      }
      .professional-dashboard-table td {
        font-size: 0.9rem;
      }
      .professional-dashboard-period-btn {
        border-radius: 999px;
        border: 1px solid transparent;
        padding: 6px 14px;
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        transition: all 0.2s ease;
        background: transparent;
        color: #9ca3af;
      }
      .professional-dashboard-period-btn.active {
        background: rgba(255, 255, 255, 0.12);
        color: #fff;
        border-color: rgba(255, 255, 255, 0.25);
      }
            .pd-hidden {
        display: none !important;
      }

      .pd-modal {
        position: fixed;
        inset: 0;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
      }

      .pd-modal__backdrop {
        position: absolute;
        inset: 0;
        background: rgba(0,0,0,0.7);
      }

      .pd-modal__panel {
        position: relative;
        width: min(520px, 92vw);
        border-radius: 16px;
        border: 1px solid rgba(255,255,255,0.18);
        background: #0b0b0b;
        color: #fff;
        padding: 18px;
        box-shadow: 0 24px 60px rgba(0,0,0,0.55);
      }

      .pd-modal__top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 14px;
      }

      .pd-modal__title {
        font-size: 18px;
        font-weight: 700;
        line-height: 1.2;
      }

      .pd-modal__sub {
        margin-top: 4px;
        font-size: 13px;
        color: rgba(156, 163, 175, 1);
      }

      .pd-modal__link {
        background: transparent;
        border: 0;
        color: rgba(156, 163, 175, 1);
        cursor: pointer;
        padding: 6px 10px;
        border-radius: 999px;
      }

      .pd-modal__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        margin-top: 10px;
      }

      .pd-modal__label {
        font-size: 12px;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(148, 163, 184, 0.9);
        margin-bottom: 6px;
      }

      .pd-modal__input {
        width: 100%;
        border-radius: 10px;
        border: 1px solid rgba(255,255,255,0.18);
        background: rgba(255,255,255,0.06);
        color: #fff;
        padding: 10px 12px;
        font: inherit;
      }

      .pd-modal__actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 16px;
      }

      .pd-modal__btn {
        border-radius: 999px;
        border: 1px solid rgba(255,255,255,0.18);
        padding: 8px 14px;
        font-size: 0.85rem;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        background: transparent;
        color: #fff;
        cursor: pointer;
      }

      .pd-modal__btn--ghost {
        background: transparent;
        color: rgba(156, 163, 175, 1);
      }

      .pd-modal__btn--primary {
        background: rgba(255,255,255,0.14);
        border-color: rgba(255,255,255,0.22);
      }

      @media (max-width: 520px) {
        .pd-modal__grid {
          grid-template-columns: 1fr;
        }
      }

    `
    document.head.appendChild(style)
  }

  const resolveApiBase = (root) => {
    const attrValue = root.dataset.apiBaseUrl?.trim()
    if (attrValue) return attrValue.replace(/\/+$/, '')
    const globalValue = window.PROFESSIONAL_DASHBOARD_API_URL || window.PROFESSIONAL_DASHBOARD_API_BASE_URL
    if (globalValue) return `${globalValue}`.replace(/\/+$/, '')
    return null
  }

  const parseLimit = (value, fallback) => {
    if (value == null) return fallback
    const parsed = Number(value)
    if (Number.isNaN(parsed)) return fallback
    return Math.max(1, Math.floor(parsed))
  }

  const localStartOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)
  const localStartOfYear = (date) => new Date(date.getFullYear(), 0, 1, 0, 0, 0)
  const toIsoString = (value) => (value ? value.toISOString() : null)

  const getRangeForPeriod = (period) => {
    const now = new Date()
    if (period === 'ytd') {
      return { start: localStartOfYear(now), end: now }
    }
    if (period === 'all') {
      return { start: new Date(0), end: now }
    }
    return { start: localStartOfMonth(now), end: now }
  }

  const buildRequestUrl = (base, path, params = {}) => {
    const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    const url = new URL(normalizedPath, normalizedBase)
    Object.entries(params).forEach(([key, value]) => {
      if (value != null) {
        url.searchParams.set(key, value)
      }
    })
    return url.toString()
  }

  const buildMetaText = (payload, period) => {
  if (period === 'all') return ''

  const startLabel = formatDate(payload?.startDate)
  const endLabel = formatDate(payload?.endDate)

  if (startLabel && endLabel) return `${startLabel} - ${endLabel}`
  return ''
}



  const renderTable = (container, rows, columns, emptyMessage) => {
    container.innerHTML = ''
    const table = document.createElement('table')
    table.className = 'professional-dashboard-table'

    const thead = document.createElement('thead')
    const headerRow = document.createElement('tr')
    columns.forEach(({ label, align }) => {
      const th = document.createElement('th')
      th.textContent = label
      th.style.textAlign = align || 'left'
      headerRow.appendChild(th)
    })
    thead.appendChild(headerRow)
    table.appendChild(thead)

    const tbody = document.createElement('tbody')

    if (!rows.length) {
      const emptyRow = document.createElement('tr')
      const emptyCell = document.createElement('td')
      emptyCell.colSpan = columns.length
      emptyCell.style.textAlign = 'center'
      emptyCell.textContent = emptyMessage
      emptyRow.appendChild(emptyCell)
      tbody.appendChild(emptyRow)
    } else {
      rows.forEach((row, index) => {
        const tr = document.createElement('tr')
        columns.forEach(({ key, renderer, align }) => {
          const td = document.createElement('td')
          td.style.textAlign = align || 'left'
          const content = renderer ? renderer(row, index) : row[key]
          td.textContent = content ?? ''
          tr.appendChild(td)
        })
        tbody.appendChild(tr)
      })
    }

    table.appendChild(tbody)
    container.appendChild(table)
  }

  const initialize = () => {
    const root = document.querySelector(ROOT_SELECTOR)
    if (!root) return

    const apiBase = resolveApiBase(root)
    if (!apiBase) {
      console.error('Professional Dashboard: missing API base URL. Provide `data-api-base-url` or set `window.PROFESSIONAL_DASHBOARD_API_URL`.')
      return
    }

    ensureStyles()

    const apiPath = root.dataset.apiPath?.trim() || DEFAULT_API_PATH
    const limit = parseLimit(root.dataset.limit, DEFAULT_LIMIT)
    const salesContainer = root.querySelector('[data-table="sales"]')
    const ordersContainer = root.querySelector('[data-table="orders"]')
    const metaEl = root.querySelector('[data-meta]')
    const periodLabelEl = root.querySelector('[data-period-label]')
    const buttons = Array.from(root.querySelectorAll('[data-period-btn]'))
    const rangeModal = root.querySelector('[data-range-modal]')
    const rangeStartInput = root.querySelector('[data-range-start]')
    const rangeEndInput = root.querySelector('[data-range-end]')
    const rangeApplyBtn = root.querySelector('[data-apply-range]')
    const rangeCancelEls = Array.from(root.querySelectorAll('[data-range-cancel]'))


    if (!salesContainer || !ordersContainer) {
      console.error('Professional Dashboard: missing `[data-table="sales"]` or `[data-table="orders"]` container.')
      return
    }

    const state = { period: 'month', isLoading: false, lastFetchedAt: null, customStart: null, customEnd: null }


    const updatePeriodLabel = (label) => {
      if (!periodLabelEl) return
      periodLabelEl.textContent = label || PERIOD_TITLES[state.period] || 'Month'
    }

    const updateMeta = (payload) => {
  if (!metaEl) return
  metaEl.textContent = buildMetaText(payload, state.period)
}


    const salesColumns = [
      { label: 'Professional', key: 'name', align: 'left' },
      { label: 'Sales', key: 'sales', renderer: (row) => formatCurrency(row.sales), align: 'right' },
    ]

    const ordersColumns = [
      { label: 'Professional', key: 'name', align: 'left' },
      { label: 'Orders', key: 'orders', align: 'right' },
    ]

    const renderPayload = (payload) => {
      const highestSales = Array.isArray(payload?.highestSales) ? payload.highestSales : []
      const mostOrders = Array.isArray(payload?.mostOrders) ? payload.mostOrders : []

      renderTable(salesContainer, highestSales, salesColumns, 'No professionals available yet.')
      renderTable(ordersContainer, mostOrders, ordersColumns, 'No professionals available yet.')
      state.lastFetchedAt = new Date()
      updatePeriodLabel(payload?.periodLabel)
      updateMeta(payload)
    }

        const openRangeModal = () => {
      if (!rangeModal) return

      const now = new Date()
      const defaultStart = localStartOfMonth(now)
      const start = state.customStart || defaultStart
      const end = state.customEnd || now

      if (rangeStartInput) rangeStartInput.value = toDateInputValue(start)
      if (rangeEndInput) rangeEndInput.value = toDateInputValue(end)

      rangeModal.classList.remove('pd-hidden')
      rangeModal.setAttribute('aria-hidden', 'false')
    }

    const closeRangeModal = () => {
      if (!rangeModal) return
      rangeModal.classList.add('pd-hidden')
      rangeModal.setAttribute('aria-hidden', 'true')
    }

    const toDateInputValue = (date) => {
      const d = new Date(date)
      if (Number.isNaN(d.getTime())) return ''
      const year = d.getFullYear()
      const month = `${d.getMonth() + 1}`.padStart(2, '0')
      const day = `${d.getDate()}`.padStart(2, '0')
      return `${year}-${month}-${day}`
    }

    const fromDateInputValueStart = (value) => {
      if (!value) return null
      const [y, m, d] = value.split('-').map(Number)
      if (!y || !m || !d) return null
      return new Date(y, m - 1, d, 0, 0, 0)
    }

    const fromDateInputValueEnd = (value) => {
      if (!value) return null
      const [y, m, d] = value.split('-').map(Number)
      if (!y || !m || !d) return null
      return new Date(y, m - 1, d, 23, 59, 59)
    }


    const requestPayload = async () => {
      if (state.isLoading) return
      state.isLoading = true
      if (metaEl) metaEl.textContent = 'Loading leaderboard…'

      try {
        const params = { period: state.period, limit }
                let start = null
        let end = null

        if (state.period === 'custom') {
          start = state.customStart
          end = state.customEnd
        } else {
          const range = getRangeForPeriod(state.period)
          start = range.start
          end = range.end
        }

        const startDate = toIsoString(start)
        const endDate = toIsoString(end)
        if (startDate) params.startDate = startDate
        if (endDate) params.endDate = endDate

        const url = buildRequestUrl(apiBase, apiPath, params)
        const response = await fetch(url, {
          cache: 'no-cache',
          headers: { Accept: 'application/json' }
        })
        const payload = await response.json().catch(() => null)

        if (!response.ok) {
          const message = payload?.error || 'Unable to load leaderboard data.'
          throw new Error(message)
        }

        renderPayload(payload ?? {})
      } catch (error) {
        if (metaEl) metaEl.textContent = error.message || 'Unable to load leaderboard data.'
        console.error(error)
      } finally {
        state.isLoading = false
      }
    }

    const decorateButtons = () => {
  buttons.forEach((button) => {
    button.classList.add('professional-dashboard-period-btn')
    const targetPeriod = button.dataset.period
    button.classList.toggle('active', targetPeriod === state.period)

    button.addEventListener('click', () => {
      if (!targetPeriod) return

      if (targetPeriod === 'custom') {
        state.period = 'custom'
        buttons.forEach((btn) => btn.classList.toggle('active', btn.dataset.period === state.period))
        updatePeriodLabel('Custom')
        openRangeModal()
        return
      }

      if (state.period === targetPeriod) return
      state.period = targetPeriod
      buttons.forEach((btn) => btn.classList.toggle('active', btn.dataset.period === state.period))
      updatePeriodLabel(PERIOD_TITLES[state.period])
      requestPayload()
    })
  })
}


    updatePeriodLabel(PERIOD_TITLES[state.period])
    decorateButtons()
    rangeCancelEls.forEach((el) => {
  el.addEventListener('click', closeRangeModal)
})

if (rangeApplyBtn) {
  rangeApplyBtn.addEventListener('click', () => {
    const start = fromDateInputValueStart(rangeStartInput?.value)
    const end = fromDateInputValueEnd(rangeEndInput?.value)

    if (!start || !end) {
      if (metaEl) metaEl.textContent = 'Select both a start and end date.'
      return
    }

    if (start.getTime() > end.getTime()) {
      if (metaEl) metaEl.textContent = 'Start date must be before end date.'
      return
    }

    state.customStart = start
    state.customEnd = end
    closeRangeModal()
    requestPayload()
  })
}

    requestPayload()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize)
  } else {
    initialize()
  }
})()
